import { reduce } from 'lodash'

export default {
  hasSelected () {
    return reduce(this.schedules, (old, current) => {
      return old || current._selected
    }, false)
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/schedulings/index/resources/computed.js